module.exports = __webpack_public_path__ + "img/slider-1.7e85b232.jpg";